@if(challenge){
  <div class="py-3 px-1">
    <a [routerLink]="['/challenges/challenge', challenge._id]" class=" min-w-64 w-full max-w-[440px]  block p-2 rounded-lg overflow-hidden shadow-lg text-normal hover:z-10 transition-transform origin-center duration-300 transform hover:scale-105">
      <div class="relative">
        <img loading="lazy"  [src]="challenge.bannerId.s3Url" [alt]="challenge.gameId.name" class="w-full h-48 object-cover rounded-lg">
        <img loading="lazy"  [src]="challenge.gameId.logoId.s3Url" alt="Profile Picture" class="absolute top-1 left-1 w-10 h-10 rounded-full border-2 border-gray-700">
        <div class="absolute bottom-2 left-2">
          <div class="text-sm bg-gray-900 text-gray-400 bg-opacity-75 rounded-lg p-1 mt-1">{{'top'| translate}} - {{challenge.prizes.length}}</div>
          <div class="text-xs text-gray-400 bg-gray-900 bg-opacity-75 rounded-lg p-1 mt-1">{{challenge.challengeTemplateId.teamMembersCount}} in team</div>
        </div>
      </div>
      <div class="py-2">
        <div class="flex justify-start items-center">
          <img loading="lazy"  [src]="challenge.publisherId?.avatarUrl" alt="Profile Picture" class="w-10 h-10 rounded-full border-2 border-gray-700">
          <h2 class="text-lg ml-2 font-semibold overflow-hidden text-ellipsis whitespace-normal line-clamp-2">{{challenge.name}}</h2>
        </div>
      </div>
      <div class="py-2 grid gap-2 grid-cols-2 items-center justify-space-between">
        <div class="text-sm mt-2">
          <span>{{challenge.endRegistrationTime | date : 'YYYY MMM dd'}}</span>
        </div>
        <div class="flex text-sm justify-between items-center">
          <span>{{challenge.endRegistrationTime | date : 'HH:mm'}}</span>
          @if(challenge.allowedLocations?.length){

            @for(location of challenge.allowedLocations; track location){
              <img loading="lazy"  src="/assets/flags/{{location}}.ico" alt="Flag" class="w-4 h-4">
            }
          } @else {
            <img loading="lazy"  src="/assets/flags/global.svg" alt="global" class="w-4 h-4"/>
          }
        </div>
        <div class="bg-gray-700 text-12 rounded-full h-4 text-center relative">
          <span class="relative z-10">{{ challenge.playersCount }} / {{challenge.exactlyPlayersCount || challenge.maxPlayersCount}}</span>
          <div class="bg-primary absolute top-0 left-0 h-4 rounded-full text-xs" style="width: {{ (challenge.playersCount / (challenge.exactlyPlayersCount || challenge.maxPlayersCount))* 100 }}%;">
          </div>
        </div>
        <div class=" text-normal font-semibold text-right px-2 rounded-md">
          <app-ticket [ticket]="challenge.enterTickets"></app-ticket>
        </div>
      </div>

    </a>
  </div>

}
